import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { OrcamentoEspelhoDTO } from '../../../../models/financeiro.model';
import { ParametrosService } from '../../../../services/parametros.service';
import { Parametros } from '../../../../models/parametros.model';
import { formatarMoedaBRL } from '../../../../core/utils/moeda.util';

@Component({
  selector: 'app-orcamento-pdf',
  standalone: true,
  templateUrl: './orcamento-pdf.component.html'
})
export class OrcamentoPdfComponent {

  parametrosEspelho: Parametros[] = [];
  constructor(private toastr: ToastrService, 
    private parametros: ParametrosService) {
        parametros.getParametrosByCategorias(['ESPELHO_ORCAMENTO']).subscribe({
        next: (params) => {
            this.parametrosEspelho = params;
          
        },
        error: () => {
          this.toastr.error('Erro ao carregar parâmetros para o orçamento. A logo pode não ser exibida corretamente.');
        }
      });

    }

  printOrcamento(espelho: OrcamentoEspelhoDTO): void {
    const printWindow = window.open('', '_blank');
    const prazo = this.parametrosEspelho.find(p => p.valorMaximo === 'PRAZO')?.valorNumerico || '40';
    const parcelas = this.parametrosEspelho.find(p => p.valorMaximo === 'PARCELAS')?.valorNumerico || '6';
    const desconto = this.parametrosEspelho.find(p => p.valorMaximo === 'DESCONTO')?.valorNumerico || '5';
    

    if (!printWindow) {
      this.toastr.warning('Não foi possível abrir a janela de impressão. Verifique se o bloqueador de pop-up está ativo.');
      return;
    }

    const formatCurrency = (value: number | null | undefined): string => formatarMoedaBRL(value ?? 0);

    const formatDate = (value: string | null | undefined): string => {
      if (!value) return '-';
      const date = new Date(value);
      return Number.isNaN(date.getTime()) ? '-' : date.toLocaleDateString('pt-BR');
    };

    const formatPhone = (value: string | null | undefined): string => {
      const digits = String(value ?? '').replace(/\D/g, '');

      if (digits.length === 11) {
        return digits.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      }

      if (digits.length === 10) {
        return digits.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
      }

      if (digits.length === 13 && digits.startsWith('55')) {
        return digits.replace(/(\d{2})(\d{2})(\d{5})(\d{4})/, '+$1 ($2) $3-$4');
      }

      return value?.trim() || '-';
    };

    const esc = (value: string | number | null | undefined): string => {
      return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    };

    const itensRows = (espelho.itens ?? [])
      .map((item) => `
        <tr>
          <td class="center">${esc(item.numItem)}</td>
          <td>${esc(item.descricaoGrupo)}</td>
          <td>${esc(item.observacaoItem)}</td>
          <td class="right">${esc(item.quantidadeGrupo)}</td>
          <td class="right">${esc(formatCurrency(item.precoTotal))}</td>
        </tr>
      `).join('');

    const h = espelho.header;
    const f = espelho.footer;

    const custoInstalacaoHtml = (f?.custoInstalacao ?? 0) > 0
      ? `<div class="total-line"><span>Custo de Produção</span><span>${esc(formatCurrency(f?.custoInstalacao))}</span></div>`
      : '';

    const html = `<!DOCTYPE html>
<html lang="pt-BR">
<head>
  <meta charset="UTF-8" />
  <title>Orçamento #${esc(h?.orcamentoId)}</title>
  <style>
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body {
      font-family: Arial, Helvetica, sans-serif;
      font-size: 12px;
      color: #1e293b;
      background: #e5e7eb;
    }

    .page {
      width: 210mm;
      min-height: 297mm;
      margin: 16px auto 24px;
      background: #fff;
      box-shadow: 0 8px 24px rgba(15,23,42,.15);
      padding: 10mm 12mm 14mm;
    }

    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 3px solid #1e3a5f;
      padding-bottom: 14px;
      margin-bottom: 14px;
      gap: 16px;
    }
    .logo-wrap {
      flex-shrink: 0;
      width: 80px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .logo-wrap img {
      max-width: 80px;
      max-height: 80px;
      object-fit: contain;
    }
    .company-center { text-align: center; flex: 1; }
    .company-name  { font-size: 24px; font-weight: 700; color: #3b6bc0; margin-bottom: 4px; }
    .company-details { font-size: 11px; color: #475569; line-height: 1.7; }
    .spacer { width: 80px; flex-shrink: 0; }

    .meta {
      display: flex;
      justify-content: space-between;
      padding: 8px 0;
      border-bottom: 1px solid #e2e8f0;
      margin-bottom: 14px;
    }
    .meta-block .lbl { font-weight: 700; font-size: 11px; }
    .meta-block .val { font-size: 11px; color: #475569; margin-top: 2px; }

    .two-col {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 16px;
      margin-bottom: 16px;
    }
    .sec-title {
      font-weight: 700;
      font-size: 12px;
      color: #1e3a5f;
      border-bottom: 1px solid #cbd5e1;
      padding-bottom: 4px;
      margin-bottom: 8px;
    }
    .field-lbl { font-weight: 700; font-size: 11px; margin-bottom: 1px; }
    .field-val  { font-size: 11px; color: #334155; margin-bottom: 6px; }

    table { width: 100%; border-collapse: collapse; margin-bottom: 8px; }
    th {
      background: #f1f5f9;
      color: #3b6bc0;
      font-weight: 700;
      font-size: 11px;
      padding: 7px 8px;
      border: 1px solid #cbd5e1;
      text-align: left;
    }
    td {
      border: 1px solid #e2e8f0;
      padding: 6px 8px;
      font-size: 11px;
      vertical-align: top;
    }
    tr:nth-child(even) td { background: #f8fafc; }
    .center { text-align: center; }
    .right  { text-align: right; white-space: nowrap; }

    .totals-wrap { display: flex; justify-content: flex-end; margin: 4px 0 0; }
    .totals-box  { width: 270px; }
    .total-line  {
      display: flex;
      justify-content: space-between;
      padding: 4px 0;
      border-bottom: 1px solid #e2e8f0;
      font-size: 12px;
    }
    .total-final {
      display: flex;
      justify-content: space-between;
      padding: 6px 0;
      font-size: 15px;
      font-weight: 700;
      color: #1e3a5f;
    }

    .no-print {
      width: 210mm;
      margin: 12px auto 0;
      display: flex;
      justify-content: flex-end;
    }
    .no-print button {
      padding: 8px 14px;
      background: #1e3a5f;
      color: #fff;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-size: 12px;
    }
    /* ── FOOTER ── */
    .footer {
      border-top: 1px solid #cbd5e1;
      padding-top: 12px;
      margin-top: 4px;
    }

    /* linha: formas de pagamento (esquerda) + TOTAL (direita) */
    .footer-main {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 24px;
      margin-bottom: 16px;
    }
      /* caixas de observações */
    .obs-box {
      border: 1px solid #334155;
      padding: 7px 9px;
      margin-top: -1px; /* colapsa bordas entre caixas */
    }
    .obs-title { font-weight: 700; font-size: 11px; margin-bottom: 2px; }
    .obs-text  { font-size: 10.5px; color: #334155; line-height: 1.5; }

    @media print {
      body { background: #fff; }
      .no-print { display: none; }
      .page { width: 100%; min-height: auto; margin: 0; box-shadow: none; padding: 0; }
      @page { size: A4 portrait; margin: 10mm; }
    }
  </style>
</head>
<body>
  <div class="no-print">
    <button onclick="window.print()">Imprimir / Salvar PDF</button>
  </div>

  <div class="page">
    <div class="header">
      <div class="logo-wrap">
        <img src="${window.location.origin}/assets/logo/logo_transparente.png" alt="Logo" />
      </div>
      <div class="company-center">
        <div class="company-name">${esc(h?.empresaNomeFantasia)}</div>
        <div class="company-details">
        ${esc(h?.empresaRazaoSocial)}<br>
          ${esc(h?.empresaEndereco)}<br>
          Telefone/Whatsapp: ${esc(formatPhone(h?.empresaTelefone))}<br>
          Email: ${esc(h?.empresaEmail)}
        </div>
      </div>
      <div class="spacer"></div>
    </div>

    <div class="meta">
      <div class="meta-block">
        <div class="lbl">Num. Orçamento</div>
        <div class="val">#${esc(h?.orcamentoId)}</div>
      </div>
      <div class="meta-block">
        <div class="lbl">Data</div>
        <div class="val">${esc(formatDate(h?.dataOrigemOrcamento))}</div>
      </div>
      <div class="meta-block" style="text-align:right">
        <div class="lbl">Validade</div>
        <div class="val">${esc(formatDate(h?.dataValidadeOrcamento))}</div>
      </div>
    </div>

    <div class="two-col">
      <div>
        <div class="sec-title">Dados do Cliente</div>
        <div class="field-lbl">Nome</div>
        <div class="field-val">${esc(h?.clienteNome)}</div>
        <div class="field-lbl">Endereço da instalação</div>
        <div class="field-val">${esc(h?.clienteEndereco)}</div>
        <div class="field-lbl">Município / UF</div>
        <div class="field-val">${esc(h?.clienteMunicipio)} / ${esc(h?.clienteUf)}</div>
        <div class="field-lbl">Telefone</div>
        <div class="field-val">${esc(formatPhone(h?.clienteTelefone))}</div>
      </div>
      <div>
        <div class="sec-title">Vendedor / Medidor</div>
        <div class="field-lbl">Nome</div>
        <div class="field-val">${esc(h?.vendedorNome)}</div>
      </div>
    </div>

    <table>
      <thead>
        <tr>
          <th class="center" style="width:46px">Num Item</th>
          <th>Descrição</th>
          <th style="width:150px">Observação</th>
          <th class="right" style="width:50px">Qtd</th>
          <th class="right" style="width:100px">Preço Total</th>
        </tr>
      </thead>
      <tbody>
        ${itensRows || '<tr><td colspan="6" class="center">Sem itens</td></tr>'}
      </tbody>
    </table>

    <div class="totals-wrap">
      <div class="totals-box">
        <div class="total-final">
          <span>TOTAL</span>
          <span>${esc(formatCurrency(f?.valorTotal))}</span>
        </div>
      </div>
    </div>


     <!-- FOOTER -->
    <div class="footer">

      <!-- Formas de pagamento (esq) + Total (dir) -->
      <div class="footer-main">
        <div class="payment-block">
          <p class="payment-title">Formas de pagamento para o orçamento completo</p>
          <p class="payment-item">Entrada de 30% e restante em até ${esc(parcelas)}x sem juros no cartão &nbsp;(Bandeiras Master/Visa)</p>
          <p class="payment-item">Em até ${esc(parcelas)}x sem juros no cartão, pagamento antecipado no ato da compra &nbsp;(Bandeiras Master/Visa)</p>
          <p class="payment-item">A vista ${esc(desconto)}% de desconto (Pix/Espécie) no ato da compra</p>
          <p class="payment-item">Para demais bandeiras de cartão, consulte condições especiais</p>
        </div>
      </div>

      <!-- Observações fixas -->
      <div class="obs-box">
        <p class="obs-title">Quanto ao Prazo:</p>
        <p class="obs-text">O prazo para entrega é de ${esc(prazo)} dias, contados a partir do pagamento da entrada, caso a medição já esteja definida. Caso contrário, o prazo inicia-se a partir da medição final.</p>
        <p class="obs-text">Soleira e Peitoril possuem prazos especiais que devem ser consultados com o vendedor</p>
        
        </div>
      <div class="obs-box">
        <p class="obs-title">Quanto à Naturalidade das Pedras:</p>
        <p class="obs-text">As pedras, por sua natureza, apresentam variações em cores e padrões. Essa diversidade estética confere singularidade a cada peça, podendo haver diferenças em relação aos modelos apresentados nas amostras.</p>
      </div>
      <div class="obs-box">
        <p class="obs-title">Quanto às Medidas Finais:</p>
        <p class="obs-text">As medidas finais devem ser confirmadas com o local devidamente preparado para a instalação. Se o projeto for elaborado por terceiros, não nos responsabilizamos por quaisquer incompatibilidades ou falhas nas medidas que possam ocorrer devido a discrepâncias entre o projeto e as medidas definitivas.</p>
      </div>

    </div><!-- /footer -->
  </div>
  <script>
    window.addEventListener('load', () => { window.focus(); window.print(); });
  </script>
</body>
</html>`;

    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();
  }



}